export enum MapboxSourceLayers {
  Building = "building",
  Road = "road",
  Landuse = "landuse",
}

export const roadAndPathWayLayers = [
  "road-path",
  "road-pedestrian",
  "road-street",
  "road-primary",
  "road-secondary-tertiary",
  "road-minor",
  "road-motorway-trunk",
];
